<template>
  <div class="app-personal-data-wrapper">
    <ViewPersonalData v-if="getView === 'viewPersonalData'">
      <template #beforePersonalData><slot name="viewBeforePersonalData"></slot></template>
      <template #labelSalutation><slot name="personalDataLabelSalutation"></slot></template>
      <template #labelLastName><slot name="personalDataLabelLastName"></slot></template>
      <template #labelFirstName><slot name="personalDataLabelFirstName"></slot></template>
      <template #labelStreetNumberView><slot name="personalDataLabelStreetNumber"></slot></template>
      <template #labelZipCityView><slot name="personalDataLabelZipCity"></slot></template>
      <template #labelSupplement><slot name="personalDataLabelSupplement"></slot></template>
      <template #labelBirthDate><slot name="personalDataLabelBirthDate"></slot></template>
      <template #labelEmail><slot name="personalDataLabelEmail"></slot></template>
      <template #btnNextStepper><slot name="btnNextStepperView"></slot></template>
    </ViewPersonalData>
    <ChangePersonalData v-if="getView === 'changePersonalData'">
      <template #beforePersonalData><slot name="changeBeforePersonalData"></slot></template>
      <template #labelSalutation><slot name="personalDataLabelSalutation"></slot></template>
      <template #labelLastName><slot name="personalDataLabelLastName"></slot></template>
      <template #labelFirstName><slot name="personalDataLabelFirstName"></slot></template>
      <template #labelStreetNumber><slot name="personalDataLabelStreetNumber"></slot></template>
      <template #labelZipCity><slot name="personalDataLabelZipCity"></slot></template>
      <template #labelSupplement><slot name="personalDataLabelSupplement"></slot></template>
      <template #labelBirthDate><slot name="personalDataLabelBirthDate"></slot></template>
      <template #labelEmail><slot name="personalDataLabelEmail"></slot></template>
      <template #btnPrevStepper><slot name="btnPrevStepperChange"></slot></template>
      <template #btnNextStepper><slot name="btnNextStepperChange"></slot></template>
      <template #emailLiveFeedback><slot name="changeEmailLiveFeedback"></slot></template>
      <template #emailRepeatLiveFeedback><slot name="changeEmailRepeatLiveFeedback"></slot></template>
    </ChangePersonalData>
    <PersonalDataChangeSuccess v-if="getView === 'personalDataChangeSuccess'">
      <template #beforePersonalData><slot name="successBeforePersonalData"></slot></template>
      <template #labelSalutation><slot name="personalDataLabelSalutation"></slot></template>
      <template #labelLastName><slot name="personalDataLabelLastName"></slot></template>
      <template #labelFirstName><slot name="personalDataLabelFirstName"></slot></template>
      <template #labelStreetNumber><slot name="personalDataLabelStreetNumber"></slot></template>
      <template #labelZipCity><slot name="personalDataLabelZipCity"></slot></template>
      <template #labelSupplement><slot name="personalDataLabelSupplement"></slot></template>
      <template #labelBirthDate><slot name="personalDataLabelBirthDate"></slot></template>
      <template #labelEmail><slot name="personalDataLabelEmail"></slot></template>
      <template #btnNextStepper><slot name="btnNextStepperSuccess"></slot></template>
    </PersonalDataChangeSuccess>
  </div>
</template>

<script>
import ViewPersonalData from './View.vue'
import ChangePersonalData from './Change.vue'
import PersonalDataChangeSuccess from './ChangeSuccess.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'

export default {
  name: 'PersonalDataWrapper',
  mixins: [
    transaction('personalData')
  ],
  computed: {
    ...mapGetters('personalData', [
      'getView'
    ])
  },
  created: function () {
    this.changeView('viewPersonalData')
  },
  methods: {
    ...mapMutations('personalData', [
      'changeView'
    ])
  },
  components: {
    PersonalDataChangeSuccess,
    ChangePersonalData,
    ViewPersonalData
  }
}
</script>
